import dayjs from "dayjs";
import { appRouter } from "../constants/routerConstant";
import {
  clearCurrentInternalStep,
  clearCurrentStep,
  clearFormData,
  clearQuestionBank,
  getUserToken,
  setPDFPresent,
  setEditingMode,
} from "./formStorage";
import { setSessionTimeStamp } from "./authStorage";

const SESSION_TIMESTAMP = "sessionTimestamp";

export function redirectToLogin(router, memberInformationToken) {
  const url = `${appRouter.DMQLogin}?data=${encodeURIComponent(memberInformationToken)}`;

  if (router?.push) {
    router.push(url);
  } else {
    window.location.href = url;
  }
}

function forceLogout(router, memberInformationToken) {
  clearCurrentStep();
  clearCurrentInternalStep();
  clearFormData();
  clearQuestionBank();
  setEditingMode(false);
  setPDFPresent(false);

  window.alert("Your session has expired. Please login again to resume.");
  redirectToLogin(router, memberInformationToken);
}

export const checkUserInactivity = async (router, onFinishLogic) => {
  if (typeof window === "undefined") return;
  //console.log("checkUserInactivity");
  try {
    const memberInformationToken = getUserToken();
    const sessionTime = window.localStorage.getItem(SESSION_TIMESTAMP);
    //console.log("sessionTime", sessionTime);

    if (!sessionTime) {
      //console.log("no sessionTime");
      forceLogout(router, memberInformationToken);
      return;
    }

    const storedTime = Number(sessionTime);

    if (!storedTime || isNaN(storedTime)) {
      forceLogout(router, memberInformationToken);
      return;
    }
    const currentTimestamp = dayjs().unix();

    //console.log("currentTimestamp", currentTimestamp);

    // Calculate differences
    const diffInMinutes = (currentTimestamp - storedTime) / 60;
    const diffInDays = diffInMinutes / (60 * 24);

    const maxDaysDataStorage = Number(process.env.REACT_APP_DMQ_DATA_STORAGE_SESSION || 7);

    const loginPerSessionMinutes = Number(process.env.REACT_APP_DMQ_LOGIN_SESSION || 30);
    //console.log("loginPerSessionMinutes", loginPerSessionMinutes);

    // Expiry #1: Days check (7 days default - Delete data)
    if (diffInDays >= maxDaysDataStorage) {
      //console.log("Expiry #1", diffInDays, loginPerSessionMinutes, maxDaysDataStorage);
      forceLogout(router, memberInformationToken);
      return;
    }

    // Expiry #2 → Inactivity logout (30 mins default)
    if (diffInMinutes >= loginPerSessionMinutes) {
      //console.log("Expiry #2", diffInMinutes, loginPerSessionMinutes, maxDaysDataStorage);
      setEditingMode(false);
      setPDFPresent(false);

      window.alert("Your session has expired. Please login again to resume.");
      redirectToLogin(router, memberInformationToken);
      return;
    }

    // NEW: If session NOT expired → refresh timestamp
    setSessionTimeStamp(currentTimestamp);
    //console.log("setSession");
    if (typeof onFinishLogic === "function") {
      //console.log("onFinishLogic");
      await onFinishLogic();
    }
  } catch (error) {
    //console.log("Error in inactivity check:", error);
    const memberInformationToken = getUserToken();
    forceLogout(router, memberInformationToken);
  }
};
